import { SankeyOptionKeys } from "@/types/sankeyOptions";
import SankeyIcon from "@components/SankeyIcon/SankeyIcon";
import { ChartOption } from "@features/analysis/types/chartOption";
import useAppStore from "@hooks/useAppStore";
import i18n from "@i18n/i18n";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import { Checkbox, Divider, ListItemIcon, ListItemText, ListSubheader, Menu, MenuItem, ToggleButton, Tooltip } from "@mui/material";
import { observer } from "mobx-react";
import { useState } from "react";

const SankeyOptionsToggleButton = observer(() => {
  const appStore = useAppStore();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleOptionsClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleOptionsMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Tooltip title={i18n.t("results-tab.title.chart-options.sankey")}>
        <ToggleButton value={ChartOption.ShowSankey} sx={{ borderRadius: 0 }}>
          <SankeyIcon />
        </ToggleButton>
      </Tooltip>
      <Tooltip title={i18n.t("results-tab.title.chart-options.sankey-options")}>
        <ToggleButton
          value={""}
          onClick={handleOptionsClick}
          aria-controls={open ? "sankey-options-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          sx={{ paddingLeft: 0, paddingRight: 0 }}
        >
          <ArrowDropDownIcon />
        </ToggleButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        id="sankey-options-menu"
        open={open}
        onClose={handleOptionsMenuClose}
        slotProps={{
          paper: {
            elevation: 1,
            sx: {
              border: 1,
              borderColor: "divider",
              overflow: "visible",
              "& .MuiList-root": {
                padding: 0,
              },
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <ListSubheader>{i18n.t("sankey-options.title")}</ListSubheader>
        <MenuItem onClick={() => appStore.toggleSankeyOption(SankeyOptionKeys.showScenarios)}>
          <ListItemIcon>
            <Checkbox icon={<CheckBoxOutlineBlankIcon fontSize="small" />} checkedIcon={<CheckBoxIcon fontSize="small" />} checked={appStore.sankeyOptions.showScenarios} />
          </ListItemIcon>
          <ListItemText>{i18n.t("sankey-options.layers.scenarios.title")}</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => appStore.toggleSankeyOption(SankeyOptionKeys.showModels)}>
          <ListItemIcon>
            <Checkbox icon={<CheckBoxOutlineBlankIcon fontSize="small" />} checkedIcon={<CheckBoxIcon fontSize="small" />} checked={appStore.sankeyOptions.showModels} />
          </ListItemIcon>
          <ListItemText>{i18n.t("sankey-options.layers.models.title")}</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => appStore.toggleSankeyOption(SankeyOptionKeys.showCategories)}>
          <ListItemIcon>
            <Checkbox icon={<CheckBoxOutlineBlankIcon fontSize="small" />} checkedIcon={<CheckBoxIcon fontSize="small" />} checked={appStore.sankeyOptions.showCategories} />
          </ListItemIcon>
          <ListItemText>{i18n.t("sankey-options.layers.categorys.title")}</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => appStore.toggleSankeyOption(SankeyOptionKeys.showCadMaterials)}>
          <ListItemIcon>
            <Checkbox icon={<CheckBoxOutlineBlankIcon fontSize="small" />} checkedIcon={<CheckBoxIcon fontSize="small" />} checked={appStore.sankeyOptions.showCadMaterials} />
          </ListItemIcon>
          <ListItemText>{i18n.t("sankey-options.layers.cad-materials.title")}</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => appStore.toggleSankeyOption(SankeyOptionKeys.showCo2MaterialTypes)}>
          <ListItemIcon>
            <Checkbox icon={<CheckBoxOutlineBlankIcon fontSize="small" />} checkedIcon={<CheckBoxIcon fontSize="small" />} checked={appStore.sankeyOptions.showCo2MaterialTypes} />
          </ListItemIcon>
          <ListItemText>{i18n.t("sankey-options.layers.ec-materials.title")}</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => appStore.toggleSankeyOption(SankeyOptionKeys.showSystems)}>
          <ListItemIcon>
            <Checkbox icon={<CheckBoxOutlineBlankIcon fontSize="small" />} checkedIcon={<CheckBoxIcon fontSize="small" />} checked={appStore.sankeyOptions.showSystems} />
          </ListItemIcon>
          <ListItemText>{i18n.t("sankey-options.layers.systems.title")}</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => appStore.toggleSankeyOption(SankeyOptionKeys.showSubSystems)}>
          <ListItemIcon>
            <Checkbox icon={<CheckBoxOutlineBlankIcon fontSize="small" />} checkedIcon={<CheckBoxIcon fontSize="small" />} checked={appStore.sankeyOptions.showSubSystems} />
          </ListItemIcon>
          <ListItemText>{i18n.t("sankey-options.layers.subsystems.title")}</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => appStore.toggleSankeyOption(SankeyOptionKeys.showAttributes)}>
          <ListItemIcon>
            <Checkbox icon={<CheckBoxOutlineBlankIcon fontSize="small" />} checkedIcon={<CheckBoxIcon fontSize="small" />} checked={appStore.sankeyOptions.showAttributes} />
          </ListItemIcon>
          <ListItemText>{i18n.t("sankey-options.layers.attributes.title")}</ListItemText>
        </MenuItem>
        <Divider />
        <MenuItem onClick={() => appStore.toggleSankeyOption(SankeyOptionKeys.showEmptyNodes)}>
          <ListItemIcon>
            <Checkbox icon={<CheckBoxOutlineBlankIcon fontSize="small" />} checkedIcon={<CheckBoxIcon fontSize="small" />} checked={appStore.sankeyOptions.showEmptyNodes} />
          </ListItemIcon>
          <ListItemText>{i18n.t("sankey-options.empty-nodes")}</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => appStore.toggleSankeyOption(SankeyOptionKeys.showLayerTitles)}>
          <ListItemIcon>
            <Checkbox icon={<CheckBoxOutlineBlankIcon fontSize="small" />} checkedIcon={<CheckBoxIcon fontSize="small" />} checked={appStore.sankeyOptions.showLayerTitles} />
          </ListItemIcon>
          <ListItemText>{i18n.t("sankey-options.layers.titles")}</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
});

export default SankeyOptionsToggleButton;
